import { Dialog, DialogContent, DialogTitle, CircularProgress } from "@mui/material";
import React from "react";
import AppDocuServiceCall from "../_Utils/AppDocuServiceCall";
import { notifySomething } from "../_Utils/AppDocuCommon";
import ServiceActivityDialogForm from "./_ServiceActivityDialogForm";

export default class EditServiceActivityDialog extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      itemData: null,
      loading: false,
      prevDataId: null,
    };
  }

  async componentDidUpdate(prevProps) {
    if (this.props.dataId && this.props.dataId !== prevProps.dataId) {
      this.setState({ loading: true });
      try {
        const res = await AppDocuServiceCall.getServiceActivity(this.props.dataId);
        const cal = res.data.result || {};
        await new Promise(resolve => setTimeout(resolve, 500)); // sleep 500ms
        this.setState({ itemData: cal, loading: false, prevDataId: this.props.dataId });
      } catch (e) {
        this.setState({ loading: false });
        notifySomething('Errore caricamento dati', 'error');
      }
    }
    // Reset state if dialog is closed
    if (!this.props.dataId && prevProps.dataId) {
      this.setState({ itemData: null, loading: false, prevDataId: null });
    }
  }

  updateService = async (itemData) => {
    this.setState({ loading: true });
    try {
      const res = await AppDocuServiceCall.updateServiceActivity(itemData);
      if (res.data && res.data.is_valid === false) {
        notifySomething(res.data.message || 'Error updating item', 'error');
        this.setState({ loading: false });
        return;
      }
      await this.props.onItemsChange();
      this.props.onClose();
    } catch (error) {
      console.error('Error updating item:', error);
      notifySomething('Error updating item', 'error');
    }
    this.setState({ loading: false });
  };

  handleUpdate = async () => {
    const m = this.state.itemData || {};
    const data = {
      ...m,
      service_activity: m.service_activity !== undefined && m.service_activity !== null ? m.service_activity : '',
      service_provision: m.service_provision !== undefined && m.service_provision !== null ? m.service_provision : '',
      service_time: m.service_time !== undefined && m.service_time !== null ? m.service_time : '',
      service_issue: m.service_issue !== undefined && m.service_issue !== null ? m.service_issue : '',
      service_desc: m.service_desc !== undefined && m.service_desc !== null ? m.service_desc : '',
      service_solution: m.service_solution !== undefined && m.service_solution !== null ? m.service_solution : '',
      car_brand: m.car_brand !== undefined && m.car_brand !== null ? m.car_brand : '',
      car_model: m.car_model !== undefined && m.car_model !== null ? m.car_model : '',
      car_engine_code: m.car_engine_code !== undefined && m.car_engine_code !== null ? m.car_engine_code : '',
      car_notes: m.car_notes !== undefined && m.car_notes !== null ? m.car_notes : '',
      system_type: m.system_type !== undefined && m.system_type !== null ? m.system_type : '',
      system_fuel: m.system_fuel !== undefined && m.system_fuel !== null ? m.system_fuel : '',
      system_channel: m.system_channel !== undefined && m.system_channel !== null ? m.system_channel : '',
      system_brand: m.system_brand !== undefined && m.system_brand !== null ? m.system_brand : '',
      ecu_type: m.ecu_type !== undefined && m.ecu_type !== null ? m.ecu_type : '',
      status: m.status !== undefined && m.status !== null ? m.status : '',
    };
    await this.updateService(data);
  }

  render() {
    const { itemData, loading } = this.state;
    return (
      <>
        {(!itemData || loading) ? (
          <Dialog open={!!this.props.dataId} onClose={this.props.onClose} maxWidth="sm" fullWidth>
            <DialogTitle>Edit Service Activity</DialogTitle>
            <DialogContent style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', minHeight: 120 }}>
              <CircularProgress size={40} thickness={4} />
            </DialogContent>
          </Dialog>
        ) : (
          <ServiceActivityDialogForm
            itemData={itemData}
            onChange={itemData => this.setState({ itemData })}
            loading={loading}
            onSubmit={this.handleUpdate}
            onClose={this.props.onClose}
            showUsername={false}
            title="Edit Service Activity"
            submitLabel="Update"
            disabled={loading || !itemData}
            open={!!this.props.dataId}
            editMode={true}
          />
        )}
      </>
    );
  }
}
